import React from "react";

const MenuGroupDivider = () => (
  <div className="bg-primary pl-6 pr-5 py-4">
    <div className='h-[1px] bg-[#CCE0EB]'></div>
  </div>
);

export default MenuGroupDivider;
